import React from "react";
import StyledNotification from "./StyledNotification";
import { IoIosCheckmark } from "react-icons/io";

const styleProps = {
  background: "white",
  iconBackground: "#4CD965"
};

const SuccessNotification = props => {
  return (
    <StyledNotification {...styleProps}>
      <div className="icon">
        <IoIosCheckmark />
      </div>
      <div className="content">
        <div className="title">success</div>
        <div className="text">{props.title}</div>
      </div>
      {/* <button onClick={() => props.close(props.notifId)}>x</button> */}
    </StyledNotification>
  );
};

export default SuccessNotification;
